export default __webpack_public_path__ + "static/media/jordy.8fc68e1b.png";